/**
 * Get the display name for a catalog stereo type
 * @param stereo - The stereo type from catalog
 * @returns Formatted display name
 */
export const getStereoDisplayName = (stereo?: string): string => {
    if (!stereo) {
        return '';
    }

    const stereoNameMap: Record<string, string> = {
        aistudio: 'AI Studio',
    };

    return stereoNameMap[stereo] || stereo.charAt(0).toUpperCase() + stereo.slice(1);
};
